import Connector from './connector';
import { StatementOfFactsOverview as Component } from '../StatementOfFactsOverview';

export const EntityStatementOfFacts = () => <Connector component={Component} />;
